import { render, staticRenderFns } from "./InvoiceItem.vue?vue&type=template&id=457fe2c7&scoped=true"
import script from "./InvoiceItem.vue?vue&type=script&lang=ts"
export * from "./InvoiceItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457fe2c7",
  null
  
)

export default component.exports